<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>

      <div style="font-size: 20px;">{{ selectedStore.storeName }}</div>

      <div style="height: 30px;"></div>

      <v-menu
        v-model="menu2"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="salesReportDate"
            label="返品日"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="salesReportDateForPicker"
          @input="menu2 = false"
          locale="jp-ja"
          :day-format="date => new Date(date).getDate()"
          no-title
          :events="functionEvents"
          event-color="green lighten-1"
          @change="onChangeSalesReportDate()"
        ></v-date-picker>
      </v-menu>

      <div style="height: 35px;"></div>

      <v-card>
        <v-container>
          <v-card-title>返品商品</v-card-title>

          <div style="height: 30px;"></div>

          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              :headers="headers"
              :items="reportItems"
              hide-actions
              class="elevation-1"
              style="width: 100%;    margin: 15px 0 0;"
              :search="search"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ props.header.text }}</span>
                  </template>
                  <span>{{ props.header.text }}</span>
                </v-tooltip>
              </template>
              <template v-slot:items="props">
                <tr
                  v-bind:class="{
                    'changed-class-name': props.item.isChanged,
                    'changed-over-class-name-order-send':
                      props.item.orderLimitNumber < props.item.quantity ||
                      props.item.quantity < 0
                  }"
                >
                  <td class="text-xs-left">{{ props.item.itemName }}</td>
                  <td class="text-xs-center item-num-column" width="50px">
                    <input
                      type="number"
                      name="itemNum[]"
                      v-model="props.item.quantity"
                      class="column-input-for-order"
                      min="0"
                      onfocus="this.value=''"
                      value="0"
                    />
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-flex xs12 sm12>
              <div style="height: 30px;"></div>
            </v-flex>

            <v-flex xs12 sm12>
              <v-textarea outline v-model="comments" counter="1000" label="コメント" clearable></v-textarea>
            </v-flex>

            <v-flex xs12 sm12>
              <div class="text-xs-center">
                <v-dialog v-model="dialog" width="500">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      align-center
                      block
                      v-on="on"
                      color="#4C728A"
                      dark
                      @click="forwardConfirm()"
                    >入力内容を確認する</v-btn>
                  </template>

                  <v-card>
                    <v-card-title class="headline grey lighten-2" style="padding: 10px;">返品処理確認</v-card-title>

                    <v-container>
                      <v-flex xs12 sm12>
                        <v-text-field v-model="salesReportDate" label="返品日" disabled></v-text-field>
                      </v-flex>

                      <v-data-table
                        :headers="salesReportConfirmHeader"
                        :items="selectedReportItems"
                        hide-actions
                        class="elevation-1"
                        style="width: 100%;    margin: 15px 0 0;"
                        :no-data-text="$t('noTableDataAvailable')"
                      >
                        <template slot="headerCell" slot-scope="props">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span v-on="on">{{ props.header.text }}</span>
                            </template>
                            <span>{{ props.header.text }}</span>
                          </v-tooltip>
                        </template>
                        <template v-slot:items="props">
                          <tr>
                            <td class="text-xs-left" width="100px">{{ props.item.itemName }}</td>
                            <td class="text-xs-right" width="50px">{{ props.item.quantity }}</td>
                            <!-- <td class="text-xs-right" width="50px">{{ props.item.presentQuantity }}</td> -->
                          </tr>
                        </template>
                      </v-data-table>

                      <div style="height: 35px;"></div>

                      <!-- <v-flex xs12 sm12>
                        <v-text-field
                          v-model="reportSum"
                          box
                          label="売上金額合計​"
                          prepend-inner-icon="mdi-currency-jpy"
                          readonly
                          style="font-weight:bold !important;"
                        ></v-text-field>
                      </v-flex>-->

                      <div style="height: 35px;"></div>

                      <v-flex xs12 sm12>
                        <v-textarea outline v-model="comments" label="コメント​" readonly></v-textarea>
                      </v-flex>

                      <v-divider style="margin: 30px;"></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click="registSalesReport()">登録する</v-btn>
                        <v-btn @click="dialog = false">修正する</v-btn>
                      </v-card-actions>
                    </v-container>
                  </v-card>
                </v-dialog>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>

      <div style="height: 35px;"></div>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'sales/new-user-menu' }">
            <v-icon dark left>arrow_back</v-icon>
            {{ $t('back-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'

export default {
  created() {
    console.log('created')
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    // this.$store.commit('SET_ORDER_DISP_ADD_ORDER_FORM', true)

    this.getSalesReportItems()
  },
  computed: {
    ...mapState({
      user: state => state.user,
      selectedStore: state => state.salesSession.menuSelectedStore
    })
  },
  methods: {
    customFilter(items, search) {
      console.log('custom filter')
      if (search.itemCategoryId === '#') {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemCategoryId === search.itemCategoryId) {
            return true
          } else {
            return false
          }
        })

        return filteringItems
      }
    },
    getSalesReportItems() {
      let thisObj = this

      let request = {
        storeCode: this.selectedStore.storeCode,
        salesReportDate: this.salesReportDate.replace(/\//g, '')
      }

      ServerApiCallService.salesReportItems(request)
        .then(response => {
          thisObj.reportItems = response.data.items
          // 商品の表示順 商品カテゴリ、商品名
          thisObj.reportItems.sort(function(a, b) {
            if (a.itemName > b.itemName) return 1
            if (a.itemName < b.itemName) return -1
            // a must be equal to b
            return 0
          })
          thisObj.reportItems.sort(function(a, b) {
            if (a.itemCategoryId > b.itemCategoryId) return 1
            if (a.itemCategoryId < b.itemCategoryId) return -1
            // a must be equal to b
            return 0
          })
          // 数値が入力されたstateから数値を設定する
          thisObj.reportItems.forEach(function(row) {
            let itemCode = row.itemCode
            thisObj.selectedReportItems.forEach(function(rowSelected) {
              if (itemCode === rowSelected.itemCode) {
                row.quantity = rowSelected.quantity
              }
            })
          })
          thisObj.itemCategories = response.data.itemCategories
          this.selectCategory = {
            itemCategoryId: '#',
            itemCategoryName: '全て'
          }
          thisObj.itemCategories.unshift(this.selectCategory)

          response.data.users.forEach(function(row) {
            var userList = {
              userId: row.userId,
              userName: row.userId + ' ' + row.lastName + ' ' + row.firstName
            }
            thisObj.salesUsers.push(userList)
          })

          this.existOrderByUser()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    onChangeSalesReportDate() {
      console.log('change sales report date')
      this.salesReportDate = this.salesReportDateForPicker.replace(/-/g, '/')

      console.log('now date: ' + moment().format('YYYYMMDD'))

      this.getSalesReportItems()
    },
    forwardConfirm() {
      console.log('forward confirm')
      // console.log(this.reportItems)

      let itemsFilterlingReportNum = this.reportItems.filter(
        item => item.quantity > 0 || item.presentQuantity > 0
      )

      // console.log(itemsFilterlingReportNum)
      this.selectedReportItems = itemsFilterlingReportNum

      console.log(this.selectedReportItems)

      this.reportSum = 0

      for (let i = 0; i < this.selectedReportItems.length; i++) {
        this.reportSum += Number(
          this.selectedReportItems[i].quantity *
            this.selectedReportItems[i].unitPrice
        )
      }
    },

    // TODO 売上報告済の確認
    existOrderByUser() {
      console.log('now date: ' + moment().format('YYYYMMDD'))

      var requestShippingDate = ''

      if (!this.salesReportDateForPicker) {
        requestShippingDate = moment().format('YYYYMMDD')
      } else {
        requestShippingDate = moment(this.salesReportDateForPicker).format(
          'YYYYMMDD'
        )
      }

      let request = {
        storeCode: this.selectedStore.storeCode,
        salesReportDate: requestShippingDate
      }

      console.log(request)

      ServerApiCallService.existOrderByUser(request)
        .then(response => {
          this.existsOrderData = response.data.existsOrders
          if (
            !!this.salesReportDateForPicker &&
            this.existsOrderData.includes(requestShippingDate)
          ) {
            this.dispShippingConfirmBtn = true
          } else {
            this.dispShippingConfirmBtn = false
          }
        })
        .catch(error => {})
    },
    functionEvents(date) {
      var day = date.replace(/-/g, '')
      if (this.existsOrderData.includes(day)) return true
    },
    registSalesReport() {
      console.log('test ')
      console.log(this.selectedUsers)

      this.workedUsers = []
      for (let i = 0; i < this.selectedUsers.length; i++) {
        this.workedUsers.push(this.selectedUsers[i].userId)
      }

      console.log(this.workedUsers)
      console.log(this.selectedReportItems)

      let request = {
        storeCode: this.selectedStore.storeCode,
        salesReportDate: this.salesReportDate.replace(/\//g, ''),
        workedUsers: this.workedUsers,
        comments: this.comments,
        sumTotal: this.reportSum,
        salesReportDetail: this.selectedReportItems
      }

      ServerApiCallService.registSalesReportByUser(request)
        .then(response => {})
        .catch(error => {})
    }
  },
  data() {
    return {
      search: '',
      salesReportDate: '',
      salesReportDateForPicker: '',
      selectedReportItems: [],
      comments: '',
      menu2: false,
      selectCategory: { itemCategoryId: '' },
      itemCategories: [],
      reportItems: [],
      dialog: false,
      existsOrderData: [],
      dispShippingConfirmBtn: false,
      selectedOrderManagementId: '',
      selectedSlipNumber: '',
      selectedShippingStatus: '',
      selectedCreatedUser: '',
      headers: [
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false
        },
        {
          text: '返品数',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true
        }
        // {
        //   text: '理論​在庫​',
        //   align: 'right',
        //   sortable: false,
        //   value: 'orderLimit',
        //   fixed: true
        // },
        // {
        //   text: '閉店後​在庫数',
        //   align: 'right',
        //   sortable: false,
        //   value: 'itemNum',
        //   fixed: true
        // }
      ],
      salesReportConfirmHeader: [
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          sortable: false,
          fixed: false
        },
        {
          text: '返品数',
          align: 'right',
          sortable: false,
          value: 'orderLimit',
          fixed: true
        }
      ],
      workedUsers: [],
      salesUsers: [],
      selectedUsers: [],
      reportSum: 0
    }
  }
}
</script>

<style>
tr.changed-class-name,
.theme--light.v-table
  tbody
  tr.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #d0e0ff;
}
tr.changed-class-name.changed-over-class-name-order-send,
.theme--light.v-table
  tbody
  tr.changed-over-class-name-order-send.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #ff6262 !important;
}

.column-input-for-order {
  width: 55px !important;
  height: 40px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}
.item-name-column {
  font-size: 14px !important;
  /*  width: 300px !important;*/
}
.order-limit-column.text-xs-right {
  font-size: 16px !important;
}
th.order-limit-column.text-xs-right {
  padding: 0 10px !important;
  white-space: pre-wrap !important;
  /*  width: 50px !important;*/
}
td.order-limit-column.text-xs-right {
  padding: 0 10px 0 0 !important;
  /*  width: 50px !important;*/
}
.order-limit-column.text-xs-right {
  text-align: right !important;
}
.item-num-column {
  /* width: 50px !important; */
  padding: 0 10px !important;
  font-size: 16px !important;
}
.is-ordered {
  background-color: #adadad;
}
</style>
